import * as React from "react";
import * as dayjs from "dayjs";
// Configuration file for state model result page
// Chart.js Plot config for overall trend plot
export const stateResultOptions = (plotQueryProps) => {
    return {
        responsive: true,
            elements: {
        point:{
            radius: 1
        }
    },
        plugins: {
            legend: {
                position: "bottom" as const,
                    align: "start" as const,
                    labels: {
                    usePointStyle: true,
                },
            },
            title: {
                fullSize: true,
                    font: {
                    size: 20
                },
                display: true,
                    text: "Infrastructure Australia - Market Capacity Report (Resource view)",
            }
        },
        scales: {
            x: {
                ticks: {
                    callback: function(value) {
                        // "this" is accessing the chart context when it gets applied
                        // @ts-ignore
                        let label = dayjs(this.getLabelForValue(value), "DD/MM/YYYY").month()

                        if (label == 0){
                            // There is a callback for each month. This check will only plot the single month for each year
                            // @ts-ignore
                            return dayjs(this.getLabelForValue(value)).format("YYYY")
                        }
                    }
                },
                grid: {
                    display: false,
                        drawTicks: false,
                }
            },
            y: {
                stacked: true,
                    ticks: {
                    maxTicksLimit: 5,
                    callback: function (value) {
                        return (plotQueryProps.unit == 'value' ? '$' : '') + (value / 1000000).toLocaleString() + "M";
                        // The .toLocaleString() method adds a comma separator for thousands.
                    }
                },
            }
        }
    }
}

export const stateFilterConfigList = [
    {
        name: "State", //Display name of the filter
        propID: "inState", //Filter prop name for the graphql endpoint
        listName: "executeGetState", // List name of filter options from API response
        valueKey: "State", // Key name of the filter option
        valueName: "State", // Value name of the filter option
        multiple: true,
        defaultValue: "ALL" //default value to be used for the filter
    },
    {
        name: "Super sector",
        propID: "inSuperSectorID",
        listName: "executeGetSuperSectorsList",
        valueKey: "SuperSectorID",
        valueName: "SuperSector",
        multiple: false,
        defaultValue: 0
    },
    {
        name: "Master type",
        propID: "inMasterTypeID",
        listName: "executeGetMasterTypesList",
        valueKey: "MasterTypeID",
        valueName: "MasterType",
        multiple: false,
        defaultValue: 0
    },
    {
        name: "Project type",
        propID: "inProjectTypeID",
        listName: "executeGetRawProjectTypes",
        valueKey: "RawProjectTypeID",
        valueName: "RawProjectType",
        multiple: true,
        defaultValue: 0
    },
    {
        name: "Infra-flag",
        propID: "inInfraFlag",
        listName: "executeGetInfraFlagsList",
        valueKey: "InfraFlag",
        valueName: "InfraFlag",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Plant/Labour/Equipment/Material",
        propID: "inPLEMGroupID",
        listName: "executeGetPLEMTypesList",
        valueKey: "PLEMGroupID",
        valueName: "PLEMGroup",
        multiple: false,
        defaultValue: 0
    },
    {
        name: "Level 1 group",
        propID: "inLevel1GroupID",
        listName: "executeGetL1GroupList",
        valueKey: "Lvl1GroupID",
        valueName: "Lvl1Group",
        multiple: false,
        defaultValue: 0
    },
    {
        name: "Resource group",
        propID: "inResourceGroupID",
        listName: "executeGetResourceGroupsList",
        valueKey: "ResourceGroupID",
        valueName: "ResourceGroup",
        multiple: true,
        defaultValue: 0
    },
];
